// extracted by mini-css-extract-plugin
module.exports = {"customSelect":"reactselectcustom_customSelect__3aEzd"};